import React, { useEffect, useState } from 'react'
import HeaderBar from '../HeaderBar'
import { Box, Button, Grid, Paper, Popover, Tooltip, Typography, Menu, MenuItem } from '@mui/material'
import { containerStyle, imgContainer, imgStyle } from '../formStyle'
import WORKslogans from '../WORKslogans'
import { useNavigate } from 'react-router-dom'
import { fetchWORKerAssignedDistrict, getWORKerLeads } from '../../backend/backendApis'
import HttpService from '../../backend/requestApis'
import { darkGrey, goldenColor, green, headingBlue, lightGrey, maroon, mediumGrey, orange, pureWhite, red, seaGreen, textGeen, textYellow, yellowish } from '../../assets/colors'
import { button2Style, buttonStyle, errorTextStyle } from '../../utils/commonCSS'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import CustomDropDown from '../CustomDropDown'
import { genderList, tableOffsets2, quizWAppMsg, leadWAppMsg, leadRatingLevels } from '../../utils/constants'
import UpdateWORKersLead from './UpdateWORKersLead'
import CustomMenu from '../CustomMenu'
import Loader from '../Loader'

const WORKersLeadManagement = () => {

    const navigate = useNavigate()
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [page, setPage] = useState(1)
    const [offset, setOffset] = useState(10)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [leadsData, setLeadsData] = useState([])
    const [updateDialogStatus, setUpdateDialogStatus] = useState(false)
    const [selectedLead, updateSelectedLead] = useState({})
    const [isRefresh, setIsRefresh] = useState(false)
    const [loader, setLoader] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [assignedDistrict, setAssignedDistricts] = useState([])

    const [selectedDistrict, setSelecDistrict] = useState('All')

    const updatePage = (opt) => {
      if( page === 1 && opt === 'dec'){
        setPage(1)
      } else if(page === totalPages && opt === 'inc'){
        setPage(totalPages)
      } else if( opt === 'dec'){
        setPage(page -1)
      } else {
        setPage(page + 1 )
      }
    }

    const updateOffset = (offset) => {
      setOffset(offset)
      setPage(1)
    }

    const updateLeadDialogStatus = (refresh = false) => {
      setUpdateDialogStatus(!updateDialogStatus)
      if( refresh){
        setIsRefresh(!isRefresh)

      }
    }

    const updateSelectedDistrict = (value) => {
      setSelecDistrict(() => value)
    }

    useEffect(() => {
        setLoader(true)
        let options = {
            url: getWORKerLeads,
            method: 'GET',
            params: {
              page: page,
              offset: offset,
              selectedDistrict: selectedDistrict
            },
            headers: {
                Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
            }
        }
        HttpService(options).then(resp => {
            setTotalRecords(resp?.data?.data?.totalRecords)
            setTotalPages(resp?.data?.data?.totalPages)
            setLeadsData(resp?.data?.data?.records)
            setLoader(false)
        }).catch(err => {
            if (err?.status === 403) {
              navigate('/signUp')
              setLoader(false)  
            } else {
              console.log('Error in fetching the WORKer leads: ', err)
              setErrorMessage('Error in Fetching Leads. Please Contact Support.')
              setLoader(false)
            }
            
        })

    }, [page, offset, isRefresh, selectedDistrict])

    useEffect(() => {
      setLoader(true)
      let options = {
        url: fetchWORKerAssignedDistrict,
        method: 'GET',
        params: {
          contactNumber: localStorage.getItem('contact')
        },
        headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }

      HttpService(options).then((resp) => {
        setAssignedDistricts(() => resp?.data?.data)
        setLoader(() => false)
      }).catch(err => {
        if (err?.status === 403) {
          setLoader(false) 
          navigate('/signUp') 
        } else {
          console.log('Error in fetching the assigned leads districts: ', err)
          setErrorMessage('Error in Fetching Assigned Leads Districts. Please Contact Support.')
          setLoader(false)
        }
      })
    }, [])

  return (
    <>
        <HeaderBar isReportForm={true}></HeaderBar>
        <Box style={{...containerStyle, maxWidth: "28rem"}}>
            <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <WORKslogans></WORKslogans>
            </Box>
            <Box style={{...imgContainer}}>
                <img src={require("../../assets/images/WORK_logo.png")}
                    alt='Logo'
                    style={{...imgStyle}}
                    onClick={() => navigate('/signUp')}
                >
                </img>

            </Box>

            <Typography style={{ fontSize: "1.2rem", fontWeight: 600, padding: "0.1rem 0.3rem 0.1rem 0.5rem" }}>Leads</Typography>

            <Paper style={{
                // maxHeight: '55vh',
                height: '55vh',
                overflowY: "auto",
                padding: '0rem 0.2rem 0rem 0.2rem',
                scrollbarWidth: "none",
                border: '1px solid #D3D3D3'
            }}>
              {loader && <Loader></Loader>}
              <Box style={{padding: '0.4rem 0.5rem 0.5rem 0.5rem', display: 'flex', justifyContent: 'space-between'}}>
                <Button style={{...button2Style, opacity: 0.5}}
                >
                  Filters
                </Button>
                <CustomDropDown regular={true} list={assignedDistrict} width='10rem'
                  value={selectedDistrict}
                  setFunc={updateSelectedDistrict}
                ></CustomDropDown>
              </Box>
              <Box style={{height: isMobile ? '40vh' : '43vh', overflow: 'auto', scrollbarWidth: "none"}}>
                {
                  leadsData?.length > 0 ?
                    (leadsData?.map((lead) => (
                      <Box onClick={() => {
                        updateSelectedLead(lead)
                        updateLeadDialogStatus()
                      }}>
                        <LeadRow lead={lead} isMobile={isMobile}></LeadRow>
                      </Box>
                    ))) : 
                    <Box style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
                    {errorMessage != '' ?
                    <Typography style={{...errorTextStyle, fontSize: '1rem'}}>{errorMessage}</Typography>:
                    <Typography style={{...errorTextStyle, fontSize: '1.2rem', color: headingBlue}}>No Leads</Typography>
                    }
                    </Box>
                }
                </Box>

                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.4rem 0.3rem 0rem 0.3rem'}}>
                  <Grid container spacing = {1} style={{display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                    <Grid item xs={3} sm={3}>
                      <Typography style={{color: maroon}} sx={{ fontSize: isMobile ? "0.8rem" : "0.9rem" }}>
                        {`${totalRecords ? (page - 1) * offset + 1 : 0} - ${(page * offset) < totalRecords ? (page * offset) : (totalRecords ? totalRecords : 0)}  of ${totalRecords ? totalRecords : 0}`}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Box style={{display: 'flex', justifyContent: 'center'}}>
                        {page === 1 ?
                          <>
                            <Box style={{opacity: 0.5, PointerEvent: 'none'}}>
                              <KeyboardArrowLeft></KeyboardArrowLeft>
                            </Box>
                            
                          </>
                           :
                          <KeyboardArrowLeft style={{color: headingBlue}} onClick={() => {
                            updatePage('dec')
                          }}></KeyboardArrowLeft>
                        }
                        
                        <Typography 
                          sx={{ fontSize: isMobile ? "0.8rem" : "0.9rem" }}
                          style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: headingBlue, color: pureWhite, padding: '0.3rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%'}}>
                            {page}
                          </Typography>
                        {(!totalPages || page === totalPages) ?
                          <Box style={{opacity: 0.5, PointerEvent: 'none'}}> 
                            <KeyboardArrowRight></KeyboardArrowRight> 
                          </Box>
                            : 
                          <KeyboardArrowRight
                            onClick={() => {
                              updatePage('inc')
                            }}
                          ></KeyboardArrowRight>
                        }
                        
                      </Box>
                    </Grid>
                    <Grid item xs={3} sm={3} >
                      <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <CustomDropDown list ={tableOffsets2} value={offset} setFunc={updateOffset}></CustomDropDown>
                      </Box>

                    </Grid>

                  </Grid>
                </Box>

            </Paper>


        </Box>
        <UpdateWORKersLead dialogStatus={updateDialogStatus} updateDialogStatus={updateLeadDialogStatus} data={selectedLead}></UpdateWORKersLead>
    </>
  )
}

export default WORKersLeadManagement

function LeadRow({lead, isMobile}){

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const leadMaleWAppMsg = `Assalamualaikum! Main Allama Syed Abdullah Tariq sahab ki Tanzeem WORK ki taraf se baat kar raha hoon. Aap ne WORK Official WhatsApp +919368009628 par message karke humare volunteers se baat karne ke liye apna interest dikhaya tha. Mera naam ${lead?.WORKerName} hae.
Kya aap se call pe baat karne ka sahi wakt jaan sakta hun?`

  const leadFemaleWAppMsg = `Assalamualaikum! Main Allama Syed Abdullah Tariq sahab ki Tanzeem WORK ki taraf se baat kar rahi hoon. Aap ne WORK Official WhatsApp +919368009628 par message karke humare volunteers se baat karne ke liye apna interest dikhaya tha. Mera naam ${lead?.WORKerName} hae.
Kya aap se call pe baat karne ka sahi wakt jaan sakti hun?"`

  const videoMsg = `Agar ab bhi nan jage toh\nhttps://youtu.be/iJP-jEppyHU?si=D7x1VwjqMtm17pqW`

    return(
      <>
        <Box style={{padding: '0.25rem 0.15rem 0.25rem 0.15rem', border: `1px solid ${mediumGrey}`, marginBottom: '0.15rem'}}>
          <Grid container spacing={1} style={{padding: '0.1rem 0.3rem 0.1rem 0.3rem'}}>
            <Grid item xs={2.75} sm ={2.75} style={{display: 'flex', alignItems: 'center'}}>
              <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: headingBlue }}>
                {lead.name}
              </Typography>
            </Grid>
            <Grid item xs={3} sm ={3} style={{display: 'flex', alignItems: 'center'}}>
              <a
                href={`tel:${lead.contactNumber}`}
                onClick={(e) => e.stopPropagation()}
              >
                {lead.contactNumber}
              </a>
            </Grid>
            <Grid item xs={2.75} sm ={2.75} style={{display: 'flex', alignItems: 'center'}}>
              <Typography noWrap sx={{ minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem" }}>
                {lead.district}
              </Typography>
            </Grid>
            <Grid item xs={2.75} sm ={2.75} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              {lead.leadStatus === "wrongNumber" ? (
                <Typography
                  sx={{wordBreak: "break-word", fontSize: isMobile ? "0.9rem" : "1rem", color: red }}
                >
                  Wrong Number
                </Typography>
              ) : lead.leadStatus === "notReachable" ? (
                <Typography
                  sx={{wordBreak: "break-word", minWidth: 0, textAlign: 'center', fontSize: isMobile ? "0.85rem" : "0.9rem", color: red }}
                >
                  Not Reachable
                </Typography>
              ) : lead.leadStatus === "followUp" ? (
                <Typography
                  sx={{ fontSize: isMobile ? "0.9rem" : "1rem", color: yellowish }}
                >
                  Follow UP
                </Typography>
              ) : lead.leadStatus === "closed" ? (
                <Typography
                  sx={{ fontSize: isMobile ? "0.9rem" : "1rem", color: green }}
                >
                  Closed
                </Typography>
              ) : (
                <Typography
                  noWrap
                  sx={{
                    fontSize: isMobile ? "0.9rem" : "1rem",
                    color: headingBlue,
                  }}
                >
                  Not Initiated
                </Typography>
              )}

            </Grid>
            <Grid item xs={0.75} sm ={0.75} style={{display: 'flex', alignItems: 'center'}}>
              <WhatsAppIcon 
                style={{fontSize: '1.2rem', color: textGeen, fontWeight: 500, cursor: 'pointer'}}
                onClick={handleClick}
              />
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
              >
                <MenuItem onClick={(e) => {
                    e.stopPropagation();
                    let url = `https://wa.me/91${lead.contactNumber}?text=${encodeURIComponent(lead?.WORKerGender === 'Female' ? leadFemaleWAppMsg : leadMaleWAppMsg)}`;
                    window.open(url, "_blank");
                    handleClose();
                }}>
                  Introduction Message
                </MenuItem>
                <MenuItem onClick={(e) => {
                    e.stopPropagation();
                    let url = `https://wa.me/91${lead.contactNumber}?text=${encodeURIComponent(videoMsg)}`;
                    window.open(url, "_blank");
                    handleClose();
                }}>
                  Agar Ab bhi Na Jage Toh
                </MenuItem>
              </Menu>
            </Grid>
            {lead.leadStatus === 'closed' && 
              <>
                <Grid item xs={7.5} sm={7.5} style={{
                  color: lead.remarks === '' ? darkGrey : orange,
                  marginLeft: '0.3rem',
                  marginTop: '0.2rem',
                  maxHeight: '3.5rem', overflow: 'auto', scrollbarWidth: 'none'
                }}>
                  <Typography style={{display: 'flex', alignItems: 'center', height: '100%'}}>
                    {lead.remarks|| 'No Remarks'}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4} style={{
                  color: maroon,
                  marginRight: '0.3rem', 
                  marginTop: '0.2rem',
                  maxHeight: '3.5rem', overflow: 'auto', scrollbarWidth: 'none',
                }}>
                  <Typography style={{
                    color: leadRatingLevels[lead?.leadResponse]?.color || headingBlue,
                    display: 'flex',
                    width: '98%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                    {leadRatingLevels[lead?.leadResponse]?.label}
                  </Typography>
                </Grid>
              </>
            }

          </Grid>
        </Box>
        {/* <Box
            sx={{
                marginTop: '0.2rem',
                display: "grid",
                gridTemplateColumns: " 2fr 2fr 2fr 0.5fr 0.3fr",
                gap: "0.7rem",
                border: "1px solid",
                borderColor: '#D9D9D9',
                borderRadius: "0.2rem",
                padding: "0.2rem 0.4rem",
                cursor: "pointer",
                backgroundColor: pureWhite,
                alignItems: "center",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = lightGrey)}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = pureWhite)}
          >
            <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem" }}>
              {lead.name}
            </Typography>
            <Typography
              noWrap 
              sx={{minWidth: 0,  fontSize: isMobile ? "0.9rem" : "1rem" }}
              component="a"
              href={`tel:${lead.contactNumber}`}
            >
              {lead.contactNumber}
            </Typography>
            <Typography
              noWrap
              sx={{
                minWidth: 0, 
                fontSize: isMobile ? "0.9rem" : "1rem",
                // display: "flex",
                // justifyContent: "center",
              }}
            >
              {lead.district}
            </Typography>
            <Box 
              // onClick={handleClick}
            >
            {lead.leadStatus === "wrongNumber" ? (
              <Typography
                noWrap
                sx={{ fontSize: isMobile ? "0.9rem" : "1rem", color: red }}
              >
                Wrong Number
              </Typography>
            ) : lead.leadStatus === "notReachable" ? (
              <Typography
                noWrap
                sx={{wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: red }}
              >
                Not Reachable
              </Typography>
            ) : lead.leadStatus === "followUp" ? (
              <Typography
                noWrap
                sx={{ fontSize: isMobile ? "0.9rem" : "1rem", color: yellowish }}
              >
                Follow UP
              </Typography>
            ) : lead.leadStatus === "closed" ? (
              <Typography
                noWrap
                sx={{ fontSize: isMobile ? "0.9rem" : "1rem", color: green }}
              >
                Closed
              </Typography>
            ) : (
              <Typography
                noWrap
                sx={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  color: headingBlue,
                }}
              >
                Not Initiated
              </Typography>
            )}
            </Box>
            <WhatsAppIcon 
              style={{fontSize: '1.2rem', color: textGeen, fontWeight: 500, cursor: 'pointer'}}
              onClick={(e) => {
                e.stopPropagation()
                let url = `https://wa.me/91${lead.contactNumber}?text=${encodeURIComponent(leadWAppMsg)}`
                window.open(url, "_blank")
              }}
            />
        </Box> */}
      </>
    )
}
